import { is } from 'ramda'

const TIMEOUT = 60 * 1000 // 60 minutes in ms

// data structure: { version: int | undefined, owned_subscriptions: Array<{ receipt: Base64 string, signature: Base64 string }> }

export default function (payload) {
  return this.sendEventWithCallback(
    'subscription.owned.android',
    payload,
    TIMEOUT
  ).then(data => {
    // shortcut
    if (is(Array, data.owned_subscriptions)) {
      return data
    }

    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
